<template>
  <div class="rules-box" v-show="isImageLoadaed">
    <div class="rules-desription-box">
      <div class="rules-desription-image">
        <img src="https://svncms-cdn.s3.eu-central-1.amazonaws.com/assets/cms/staging/public_general/product_numbersbetting_1_242x136.jpg" v-on:load="imageLoaded" v-show="imageLoaded" alt="">
      </div>
      <div class="rules-desription-details" v-if="configDescription">
        <div class="rules-desription-details-header">
          <h1>
            <span>{{configDescription.companyProducts[0].productName}}</span>
            <span>{{configDescription.companyProducts
            [0].companyProductVersions[0].versionMajorVersion}}</span>
          </h1>
          <h4>
            <span>{{'admin_version' | translate}}</span>
            <span>{{configDescription.companyProducts
            [0].companyProductVersions[0].versionFullKey}}</span>
          </h4>
        </div>
        <article class="rules-desription-details-content">
          <p>
            {{configDescription.companyProducts[0].description}}
          </p>
          <a href="https://www.nsoft.com" target="_blank">{{'admin_moreInfoOnWebsite' | translate}}</a>
        </article>
      </div>
    </div>
    <div class="rules-desription-content">
      <div class="rules-desription-navigation flex-center">
        <div class="platform flex-center"
             v-for="(platform, index) in platforms"
             :key="index"
             :class="{'active': activePlatform === platform.deliveryPlatform.toLowerCase()}"
             @click="!validateSchemaChanged && !rulesErrorActive
             ? setActivePlatform(platform.deliveryPlatform)
             :sendNotification(platform.deliveryPlatform.toLowerCase())">
          {{platform.deliveryPlatform}}
        </div>
      </div>
      <div class="config-contents-box" v-if="config">
        <form novalidate>
          <ConfigContentBox v-for="(schema, key) in config.validationSchema"
                            :key="key"
                            v-on:rule-input-error="checkErrorMessage"
                            v-on:rule-input-error-remove="checkErrorMessage($event, true)"
                            v-on:check-validate-schema="checkValidateSchema()"
                            :cc-schema-name="key"
                            :cc-schema-content="schema"
                            :cc-schema-values="workingConfig"
                            :cc-schema-values-raw="workingConfigRaw"
                            :active-platform="activePlatform"></ConfigContentBox>
        </form>
      </div>
    </div>
    <div class="rules-description-actions">
      <AdminButton v-on:admin-button="callActions"
                   :ab-value="'general_cancel'"
                   :ab-name="'cancel'"
                   :ab-style-name="'default filter'"></AdminButton>
      <AdminButton v-on:admin-button="callActions"
                   :ab-value="'general_save'"
                   :ab-name="'save'"
                   :ab-disabled="rulesErrorActive"
                   :ab-style-name="'primary filter rules'"></AdminButton>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import {
  concat,
  orderBy,
  assign,
  isEqual,
} from 'lodash';
import createHeaders from '../api/utility';
import { updateEdit } from '../api';
import AdminButton from '../components/AdminButton';
import ConfigContentBox from './ConfigContentBox';
import EventBus from '../store/EventBus';

export default {
  name: 'RulesBox',
  components: { ConfigContentBox, AdminButton },
  data() {
    return {
      // examples of config and product decription first is for vfl2, second is for vermantia
      isImageLoadaed: false,
      config: null,
      configDescription: null,
      generalPlatform: [{
        id: 'general',
        priority: 1,
        uuid: 'General',
        translation: 'General',
        productInstanceId: '',
        deliveryPlatform: 'General',
        isAvailable: true,
        isActive: true,
      }],
      platforms: [],
      workingConfig: {},
      workingConfigRaw: {},
      activePlatform: 'general',
      rulesErrors: [],
      rulesErrorActive: false,
      validateSchemaChanged: false,
    };
  },
  computed: {
    ...mapGetters([
      'minorActive',
      'mainView',
      'activeModules',
      'discoverServerLocation',
      'user',
      'activeModule',
      'gameId',
    ]),
  },
  async beforeMount() {
    this.configDescription = await this.fetchDescription();
    await this.fetchRules();
    this.platforms = this.configDescription
      ? orderBy(concat(this.generalPlatform, this.configDescription.companyProducts[0]
        .companyProductVersions[0].companyProductInstances), 'priority')
      : this.generalPlatform;
    EventBus.$on('notification-rule-action', (action) => {
      this.callActions(action);
    });
  },
  methods: {
    ...mapActions([
      'setActiveMinorModule',
      'setMinorActive',
      'fetchRules',
      'setActiveLoader',
      'setNotificationMessage',
    ]),
    async fetchDescription() {
      const headers = createHeaders(this.discoverServerLocation, this.user,
        { 'X-NSFT-SEVEN-ACCOUNT-ID': this.discoverServerLocation.companyUuid }, 'HTTP-X-SEVEN-COMPANY-UUID');
      let response = null;
      try {
        const rawResponse = await axios.get(`${this.discoverServerLocation.productApi.url}/admin/product-instance/${window.NB.gameUuid}`,
          { headers });
        response = rawResponse.data;
      } catch (e) {
        console.log(e);
      }
      return response;
    },
    async fetchRules() {
      this.setActiveLoader(true);
      const headers = createHeaders(this.discoverServerLocation, this.user);
      const response = await axios.get(`${this.discoverServerLocation.productApi.url}/${this.activeModule.mainTable.get}/${this.gameId}?channel=${this.activePlatform}`,
        { headers });
      this.$set(this, 'config', response.data);
      // this.config = Object.assign({}, response.data);
      this.$set(this, 'workingConfig', this.config.config);
      this.$set(this, 'workingConfigRaw', assign({}, response.data.config));
      this.setActiveLoader(false);
    },
    setActivePlatform(platform) {
      const lowercasePlatform = platform.toLowerCase();
      if (lowercasePlatform !== this.activePlatform) {
        this.resetErrors();
        this.resetConfig();
        this.activePlatform = lowercasePlatform;
        this.fetchRules();
      }
    },
    imageLoaded() {
      this.isImageLoadaed = true;
    },
    async callActions(event) {
      try {
        this.setNotificationMessage();
        const headers = createHeaders(this.discoverServerLocation, this.user);
        if (event === 'save' && !this.rulesErrorActive) {
          const data = {
            channel: this.activePlatform,
            config: this.workingConfig,
          };
          // eslint-disable-next-line no-unused-vars
          const response = await updateEdit(`${this.discoverServerLocation.productApi.url}/${this.activeModule.mainTable.update}/${this.gameId}?channel=${this.activePlatform}`, data, headers);
          this.$store.dispatch('setNotificationMessage', {
            title: response.status === 200 ? 'general_success' : 'general_error',
            description: response.status === 200 ? 'admin_changesSavedSuccessfully' : 'admin_didntSavedChanges',
            rulesActions: false,
          });
        } else {
          this.resetConfig();
          this.fetchRules();
        }
        this.validateSchemaChanged = false;
        this.resetErrors();
      } catch (e) {
        this.$store.dispatch('setNotificationMessage', {
          title: 'general_error',
          description: e.response.data.message,
          rulesActions: false,
        });
      }
    },
    checkErrorMessage(error, remove = false) {
      const index = this.rulesErrors.indexOf(error);
      if (index < 0 && !remove) {
        this.$set(this.rulesErrors, this.rulesErrors.length, error);
      } else if (index >= 0 && remove) {
        this.rulesErrors.splice(index, 1);
      }
      this.rulesErrorActive = !!this.rulesErrors.length;
    },
    resetConfig() {
      this.config = null;
    },
    resetErrors() {
      this.$set(this, 'rulesErrors', []);
      this.rulesErrorActive = false;
    },
    checkValidateSchema() {
      this.validateSchemaChanged = !isEqual(this.workingConfig, this.workingConfigRaw);
    },
    sendNotification(platform) {
      if (platform === this.activePlatform) {
        return;
      }
      this.$store.dispatch('setNotificationMessage', {
        title: 'general_warning',
        description: 'admin_warning_invalid_or_changed_field',
        rulesActions: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .rules-box {
    height: calc(100% - 50px);
  }
  .rules-desription-box {
    background-color: #f3f5f6;
    display: flex;
    padding: 15px 20px 20px;
    .rules-desription-image {
      height: 185px;
      margin: 0 20px 0 0;
      position: relative;
      width: 315px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .rules-desription-details {
      height: 185px;
      position: relative;
      width: 325px;
      h1 {
        font-family: primary-font-light;
        font-size: 26px;
      }
      h4 {
        color: #009aff;
        text-transform: capitalize;
      }
      h1, h4 {
        span {
          &:first-child {
            margin-right: 5px;
          }
        }
      }
    }
    .rules-desription-details-content {
      bottom: 0;
      left: 0;
      position: absolute;
      p {
        line-height: 1.42857143;
        margin-bottom: 20px;
        max-height: 48px;
        overflow: hidden;
        position: relative;
      }
      a {
        color: #009aff;
        font-size: 14px;
        text-decoration: none;
      }
    }
    h4,
    article > p {
      font-family: primary-font;
      font-size: 12px;
    }
  }
  .rules-desription-navigation {
    background-color: transparent;
    box-shadow: inset 0 -1px 0 0 #d3dadd;
    font-size: 14px;
    height: 50px;
    margin-bottom: 10px;
    .platform {
      color: #808b9c;
      cursor: pointer;
      height: 100%;
      padding: 0 20px;
      position: relative;
      &.active {
        color: #009aff;
        &:before {
          width: 100%;
          left: 0;
          background-color: #009aff;
        }
      }
      &:before {
        background-color: transparent;
        bottom: 0;
        content: "";
        height: 3px;
        left: 30%;
        position: absolute;
        transition: all .5s;
        width: 40%;
      }
    }
    &.minor {
      background-color: transparent;
      box-shadow: inset 0 -1px 0 0 #d3dadd;
      margin-bottom: 10px;
      .module {

        &.active {
          color: #009aff;
        }
        &:before {
          bottom: 0;
          top: auto;
        }
      }
    }
  }
  .rules-desription-content {
    padding: 5px 15px 0 20px;
    height: calc(100% - 220px - 56px);
    .config-contents-box {
      height: calc(100% - 60px);
      overflow: auto;
      form {
        align-items: flex-start;
        display: flex;
        height: 100%;
        width: 100%;
      }
    }
  }
  .rules-description-actions {
    align-items: center;
    background-color: #e8ecee;
    display: flex;
    height: 56px;
    justify-content: flex-end;
    padding-right: 15px;
    &:first-child {
      margin-right: 10px;
    }
  }
</style>
